import SortUp from 'resources/icons/sorting icons/sorting icons/assort-up.png';
import SortDown from 'resources/icons/sorting icons/sorting icons/assort-down.png';
import SortNone from 'resources/icons/sorting icons/sorting icons/assort-none.png';

/* eslint-disable  @typescript-eslint/no-explicit-any */

export const getColumnHtml = (sortColumns: any, index: String, title: string) => {
  const sortedColumn = sortColumns?.find(({ column }: { column: any }) => column.key === index);
  return (
    <div>
      {title}
      <span style={{ marginRight: '5px' }}>
        {sortedColumn ? (
          [sortedColumn.order === 'ascend' ? <img src={SortUp} alt="sortUp" /> : <img src={SortDown} alt="sortDown" />]
        ) : (
          <img src={SortNone} alt="SortNone" />
        )}
      </span>
    </div>
  );
};
